export class GSalesReportByDate {
    public StartDate: Date;
    public EndDate: Date;
    public AccId: number;
}